export enum LanguageCulureNameEnum {
  'en-CA' = 1,
  'fr-CA' = 2,
  'es-ES' = 3,
  'de-DE' = 4,
}
